import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import '../styles/article.scss'

export default function Template({ data }) {
  const article = data.markdownRemark

  return (
    <div className="content-container">
      <Helmet
        meta={[
          {
            name: 'keywords',
            content: article.frontmatter.tags,
          },
        ]}
      />
      <div className="article">
        <div className="title-container">
          <div className="title">{article.frontmatter.title}</div>
        </div>
        <div
          className="body"
          dangerouslySetInnerHTML={{ __html: article.html }}
        />
      </div>
    </div>
  )
}

export const articleQuery = graphql`
  query ArticleByPath($slug: String!) {
    markdownRemark(frontmatter: { path: { eq: $slug } }) {
      html
      frontmatter {
        path
        title
        date
        tags
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/article.js